import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import "./PaymentSuccess.css"; // import the CSS file

const PaymentSuccess = () => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const isSuccess = query.get("status") === "true";
  const [secondsRemaining, setSecondsRemaining] = useState(5);

  useEffect(() => {
    if (secondsRemaining > 0) {
      const timer = setTimeout(() => {
        setSecondsRemaining(secondsRemaining - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      // window.location.href = "/home";
      console.log("Timer ended");
    }
  }, [secondsRemaining]);

  return (
    <div className="payment-page">
      {/* // <div> */}
      {isSuccess ? (
        <>
          <h2 className="payment-success">Payment Successful!</h2>
          <p>Thank you for your payment.</p>
          <p>Your booking has been confirmed.</p>
        </>
      ) : (
        <>
          <h2 className="payment-failed">Payment Failed!</h2>
          <p>Sorry, we were unable to process your payment.</p>
          <p>Please try again later or contact customer support.</p>
        </>
      )}
      <p className="countdown-timer">
        Redirecting to Homepage in{" "}
        <span className="seconds-remaining">{secondsRemaining}</span>{" "}
      </p>
      <Link to="/home" className="home-button">
        Return to Homepage
      </Link>
    </div>
  );
};

export default PaymentSuccess;
